// extracted by mini-css-extract-plugin
export default {"root":"Loading_root__pluBG","ldsRoller":"Loading_ldsRoller__18qRg"};